<template>
    <div id="app" style="position: relative;top:115px;">
        <div class="w-1200" style="width: 1300px;">
            <div class="layui-tab layui-tab-brief" style="padding-top: 15px" lay-filter="docDemoTabBrief">
                <ul class="layui-tab-title">
                    <li v-for="(item,index) in dataList" :key="index" style="font-size: 16px;"
                        :style="item.state === 2? 'border-bottom: 2px solid #5FB878;':''" @click="Handover(index)">
                        <a class="aa" :style="item.state === 2? 'font-weight: 600;color: #f58f00;':''">{{item.name}}</a>
                    </li>
                </ul>
                <div class="layui-tab-content  itemCon platform">
                    <div class="layui-tab-item layui-show new-notice-tongzhi">
                        <!-- 轮播图 -->
                        <v-spin :spinning="loadingFlag" tip="正在读取数据." size="large" class="slideBoxa"
                            style="margin: 10px 0;">
                            <div class="bd">
                                <el-carousel :interval="500000" arrow="always">
                                    <el-carousel-item v-for="(item,index) in slideshowList1" :key="index">
                                        <img :src="item.src" :alt="item.contentTitle" :title="item.contentTitle"
                                            @error="imgerrorfun(index)" style="min-height: 240px;">
                                        <div class="tit" style="height: 50px;">
                                            <p @click="noticeDetail(item)"
                                                style="width: 350px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;color:white;cursor: pointer;">
                                                {{item.contentTitle}}
                                            </p>
                                        </div>
                                    </el-carousel-item>
                                </el-carousel>
                            </div>
                        </v-spin>
                        <!-- 右侧 -->
                        <v-spin :spinning="loadingFlag" tip="正在读取数据." size="large" class="newscon"
                            style="width: 800px;">
                            <h2>
                                <a @click="detail()"
                                    style="white-space: nowrap;overflow: hidden;width: 400px;display: inline-block;text-overflow: ellipsis;">{{contentTitle}}</a>
                            </h2>
                            <p style="text-indent:2em;">{{str}}<a style="color:#f58f00;" @click="detail()">[详细]</a></p>
                            <ul>
                                <li class="ico" v-for="(item,index) in slideshowList" :key="index"
                                    style="display: flex;justify-content: space-between;" @click="noticeDetail(item)">
                                    <a style="
                                    display: block;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    width: 650px;
                                    ">{{item.contentTitle}}</a><span>[{{item.insertTime}}]</span>
                                </li>
                            </ul>
                        </v-spin>
                    </div>
                </div>
            </div>
        </div>
        <!-- 友情链接 -->
        <div class="link">
            <dt class="pageBT" style="padding-bottom:0px;">
                <p class="zh"><span>友情链接</span></p>
                <p class="en">Friendly Link</p>
            </dt>
            <div class="mian">
                <ul class="clearfix" style="padding:20px 0;width: 900px;margin: 0 auto">
                    <li style="line-height: 30px;"><a title="中国人力资源和社会保障部" target="_blank"
                            href="http://www.mohrss.gov.cn/">中国人力资源和社会保障部</a></li>
                    <li style="line-height: 30px;"><a title="山西省人力资源和社会保障厅" target="_blank"
                            href="http://rst.shanxi.gov.cn/">山西省人力资源和社会保障厅</a></li>
                    <li style="line-height: 30px;"><a title="中国就业网" target="_blank"
                            href="http://chinajob.mohrss.gov.cn/">中国就业网</a></li>
                    <li style="line-height: 30px;"><a title="山西就业网" target="_blank"
                            href="http://chinajob.mohrss.gov.cn/">山西就业网</a></li>
                    <li style="line-height: 30px;"><a title="中国就业培训指导中心" target="_blank"
                            href="http://www.cettic.gov.cn/">中国就业培训指导中心</a></li>
                    <li style="line-height: 30px;"><a title="世界技能大赛山西组委会官方网站" target="_blank"
                            href="http://www.worldskillschina.cn/">世界技能大赛山西组委会官方网站</a></li>
                </ul>
            </div>
        </div>


    </div>
</template>
<script>

    import Vue from 'vue'
    import vuebeauty from 'vue-beauty'
    import 'vue-beauty/package/style/vue-beauty.min.css'
    Vue.use(vuebeauty)
    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                loadingFlag: false,
                id: 0,
                navName: '',
                selectFlag: false,
                dataList: [
                    {
                        name: '政策文件',
                        state: 2
                    },
                    {
                        name: '职业标准',
                        state: 1
                    }
                ],
                slideshowList: [],
                str: '',
                contentTitle: '',
                professionalStandardList: [],
                flag: true,
                slideshowList1: [],
                authorizedUnitList: []
            }
        },
        mounted() {
        },
        created() {
            //默认加载 政策文件
            this.HandoverNotificationOrPresscenterDataLoad(27);
            //职业标准
            //this.$storage.remove('token');

        },
        methods: {
            containerDetail(item) {

                this.$router.push({ path: '/journalismNoticeDetailnet/' + item.id + "/" + item.navName })

            },
            //职业标准 更多
            professionalStandardMore() {
                this.$router.push({ path: '/journalismNoticenet/6' })
            },
            noticeDetail(item) {
                this.$router.push({ path: '/journalismNoticeDetailnet/' + item.id + "/" + item.navName })
            },
            detail() {
                this.$router.push({ path: '/journalismNoticeDetailnet/' + this.id + "/" + this.navName })
            },
            imgerrorfun(index) {
                this.slideshowList[index].src = '../../static/img/logo.png';
            },
            // 首页 通知公告 / 新闻中心 切换
            Handover(index) {
                this.dataList.forEach(element => {
                    if (element.state === 2) {
                        element.state = 1;
                    }
                });
                this.dataList[index].state = 2;

                this.flag = true;
                if (index === 0) {
                    this.HandoverNotificationOrPresscenterDataLoad(27);
                } else {
                    this.HandoverNotificationOrPresscenterDataLoad(32);
                }
            },
            cutstr(str, len) {
                var str = str.replace(/<[^>]+>/g, "").replace(/[ ]|[&nbsp;]/g, '');//去掉所有的html标记
                var str_length = 0;
                var str_len = 0;
                let str_cut = new String();

                for (var i = 0; i < str.length; i++) {
                    let a = str.charAt(i);
                    str_length++;
                    if (escape(a).length > 4) {
                        //中文字符的长度经编码之后大于4
                        str_length++;
                    }
                    str_cut = str_cut.concat(a);
                    if (str_length >= len) {
                        str_cut = str_cut.concat("...");
                        return str_cut;
                    }
                }

                //如果给定字符串小于指定长度，则返回源字符串；
                if (str_length < len) {
                    return str;
                }

            },
            HandoverNotificationOrPresscenterDataLoad(navId) {
                this.loadingFlag = true;
                //加载 首页 数据  
                let parames = new URLSearchParams();
                parames.append('navId', navId); //id 类型id 
                parames.append('organStatus', this.organStatus);//  组织机构代码   1工大  2协会 3建投

                this.$axios.post(this.serverUrl + '/navList', parames).then(resp => {

                    if (resp.data.data.length > 0) {
                        let slideshowArrayList = [];

                        let slideshowArrayList1 = [];
                        resp.data.data.forEach((element, index) => {
                            let index1 = index + 1;

                            if (this.flag) {
                                this.id = element.id;

                                this.navName = element.navName;
                                this.str = this.cutstr(element.contentDesc, 170);

                                this.contentTitle = element.contentTitle;

                                if (this.str.length != 0) {
                                    this.flag = false;
                                }
                            }
                            //轮播图 最多三条
                            if (index1 <= 6) {
                                let slideshowVo = {
                                    id: 0,
                                    navName: 0,
                                    src: '',
                                    contentTitle: '',
                                    insertTime: ''
                                }

                                slideshowVo.id = element.id;
                                slideshowVo.navName = element.navName;
                                slideshowVo.src = this.serverUrl + this.prefiexUrl + element.contentPic;
                                slideshowVo.contentTitle = element.contentTitle;

                                if (element.insertTime != null) {
                                    slideshowVo.insertTime = element.insertTime.substring(0, 10);
                                } else {
                                    slideshowVo.insertTime = '暂无';
                                }
                                slideshowArrayList.push(slideshowVo);

                                if (index1 <= 3) {

                                    slideshowArrayList1.push(slideshowVo);

                                }
                            }
                        })
                        this.slideshowList = slideshowArrayList;

                        this.slideshowList1 = slideshowArrayList1;
                    }
                    this.loadingFlag = false;
                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙,请稍后再试!',
                        type: 'error'
                    })
                })
            }
        }
    }
</script>

<style scoped>
    .md-2018040201-lty .pic-box:hover {
        box-shadow: 0 0px 20px 0px rgb(221 221 221);
        margin-top: 2px;
    }

    .md-com-list .md-hd {
        padding: 15px 0 15px;
        line-height: 27px;
        overflow: hidden;
    }

    .link ul {
        width: 100%;
        overflow: hidden;
        padding: 20px 0;
    }

    .clearfix {
        display: block;
        clear: both;
    }

    .md-2018040201-lty .pic-box .hd-pic img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
    }

    .md-19120602-xxw.live .state,
    .md-2018040201-lty .pic-box.live .state {
        display: block;
        background: url(../../../static/img/authorization.png) no-repeat center center;
    }

    .md-19120602-xxw .state,
    .md-2018040201-lty .pic-box .state {
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 44px;
        z-index: 2;
        display: none;
    }

    .md-2018040201-lty .pic-box .hd-pic {
        height: 160px;
        position: relative;
    }

    .link li a {
        -moz-transition: all 0.3s ease-in-out;
        -webkit-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
        color: #666;
    }

    .link li {
        float: left;
        font-size: 14px;
        line-height: 30px;
        width: auto;
        height: auto;
        float: left;
        margin: 0px 5px;
    }

    .md-2018040201-lty .pic-box {
        position: relative;
        transition: all .1s ease;
        overflow: hidden;
        width: 224px;
        margin: 0 10px;
        border-radius: 5px;
        margin-bottom: 20px;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1228px;
    }

    div /deep/ .el-carousel__indicators--horizontal {
        bottom: 5px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    a {
        color: black;
    }

    .aa :hover {
        color: #f58f00;
    }

    .el-carousel__indicators--horizontal {
        display: none;
        bottom: 20px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }

    .tit {
        height: 40px;
        position: absolute;
        line-height: 40px;
        width: 100%;
        bottom: 0;
        left: 0px;
        text-align: left;
        text-indent: 20px;
        border-radius: 0px;
        background: rgba(0, 0, 0, 0.6);
    }
</style>


// WEBPACK FOOTER //
// src/components/internetplus/homePage.vue